import React from 'react';
import { useLocation } from "react-router-dom";

import Dashboard from '../../../pages/dashboard/DashboardHM';

const MapAccess = () => {
	const location = useLocation();

	if (location && location.state) {
		return <Dashboard location={location} />
	}

	return <Dashboard />
}

export default MapAccess;